/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@ublend-npm/react-tooltip';
import InputAdornment from '@material-ui/core/InputAdornment';

import Select from '$components/Select';
import Button from '$components/Button';

import {
  SelectContainer,
  SelectWrapper,
  TextField,
} from './AssignmentSelector.styled';

import getSelectedName from './utils/getSelectedName';

const AssignmentSelector = ({
  selectOptions,
  selectedAssignment,
  onSelectorChange,
  onDeselect,
  onWeightChange,
  isMultiple,
  disabled,
}) => {
  const { id: selectedId, weightage } = selectedAssignment || {};

  const selectedWeightage = typeof weightage === 'number' ? `${weightage}` : '';
  const selectedName = getSelectedName({ selectedId, selectOptions });

  return (
    <SelectWrapper>
      <SelectContainer>
        <Select
          options={selectOptions}
          value={selectedId}
          placeholder="Select an assignment"
          onChange={onSelectorChange}
          disabled={disabled}
        />
      </SelectContainer>
      {isMultiple && (
        <TextField
          variant="outlined"
          label="Weight"
          margin="dense"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          onChange={onWeightChange}
          value={selectedWeightage}
          aria-label={`weightage for ${selectedName}`}
          disabled={disabled}
        />
      )}
      {selectedId && onDeselect && !disabled && (
        <Tooltip title="Remove" position="right" spacing={4}>
          <div>
            <Button
              size="iconLarge"
              look="iconOnlyGrey"
              onClick={onDeselect}
              label="delete an assignment mapping"
            >
              <DeleteIcon />
            </Button>
          </div>
        </Tooltip>
      )}
    </SelectWrapper>
  );
};

AssignmentSelector.propTypes = {
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedAssignment: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onSelectorChange: PropTypes.func,
  onDeselect: PropTypes.func,
  onWeightChange: PropTypes.func,
  isMultiple: PropTypes.bool,
  disabled: PropTypes.bool,
};

AssignmentSelector.defaultProps = {
  selectedAssignment: undefined,
  onDeselect: undefined,
  onWeightChange: undefined,
  onSelectorChange: undefined,
  isMultiple: false,
  disabled: false,
};

export default AssignmentSelector;
